import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'PushNotificationHistory',
    column_type: 'id',
  },
  created_at: {
    model_name: 'PushNotificationHistory',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'PushNotificationHistory',
    column_type: 'datetime',
  },
  phones: {
    model_name: 'PushNotificationHistory',
    column_type: 'string',
  },
  creator: {
    model_name: 'PushNotificationHistory',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUsersRole',
      foreign_key: 'creator_id',
    },
  },
  creator_id: {
    model_name: 'PushNotificationHistory',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUsersRole',
      foreign_key: 'creator_id',
    },
  },
  kind: {
    model_name: 'PushNotificationHistory',
    column_type: 'enum',
  },
  read_count: {
    model_name: 'PushNotificationHistory',
    column_type: 'integer',
  },
  sent_count: {
    model_name: 'PushNotificationHistory',
    column_type: 'integer',
  },
  all_users: {
    model_name: 'PushNotificationHistory',
    column_type: 'boolean',
  },
  open_rates: {
    model_name: 'PushNotificationHistory',
    column_type: 'string',
  },
  messages: {
    model_name: 'PushNotificationHistory',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
